/*
 * Copyright (C) 2018 Spanning Cloud Apps LLC.  All rights reserved.
 */
/**
 * Service used to make webapi requests for alert rules.
 */
angular.module('http.alertRules', []).factory('httpAlertRules', function ($http) {
  return {
    addRule,
    deleteRule,
    getRules,
    updateRule
  };

  /**
   * Adds a new alert rule.
   *
   * @param {object} props - the settings of the rule to be created.
   * @returns {Promise<object>} the promise of the new alert rule.
   */
  function addRule(props) {
    return $http({
      method: 'POST',
      url: 'api/alert/rules',
      data: props
    }).then(function (res) {
      return res.data;
    });
  }

  /**
   * Deletes an alert rule.
   *
   * @param {number} id - the Spanning id of the rule to be deleted.
   * @returns {Promise<void>} the promise of the completion of the action.
   */
  function deleteRule(id) {
    return $http({
      method: 'DELETE',
      url: `api/alert/rules/${id}`
    }).then(function (res) {
      return res.data;
    });
  }

  /**
   * Returns the alert rules for the current org.
   *
   * @returns {Promise<object[]>} the promise of the list of alert rules.
   */
  function getRules() {
    return $http({
      method: 'GET',
      url: 'api/alert/rules'
    }).then(function (res) {
      return res.data;
    });
  }

  /**
   * Updates an alert rule.
   *
   * @param {number} id - the Spanning id of the rule to be updated.
   * @param {object} props - the settings of the rule to be updated.
   * @returns {Promise<object>} the promise of the updated alert rule.
   */
  function updateRule(id, props) {
    return $http({
      method: 'PATCH',
      url: `api/alert/rules/${id}`,
      data: props
    }).then(function (res) {
      return res.data;
    });
  }
});
